import React, { useState } from 'react';
import { Grid, Box, Typography, TextField, Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { changePassword } from '../../api/authApi'; // Asegúrate de importar la función changePassword

const ChangePasswordPage = () => {
    const { token } = useParams<{ token: string }>(); // Recuperar el token desde la URL

    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const handleChangePassword = async (newPassword: string) => {
        setLoading(true);
        setError('');
        setMessage('');

        if (!token) {
            setError('Token no válido.');
            setLoading(false);
            return;
        }

        try {
            const response = await changePassword(newPassword, token);
            if (response.success) {
                setMessage('Contraseña cambiada exitosamente');
                navigate('/');


            } else {
                setError('Error al cambiar la contraseña');
            }
        } catch (err) {
            setError('Ocurrió un error. Inténtalo de nuevo.');
        } finally {
            setLoading(false);
        }
    };



    return (
        <Grid
            container
            textAlign="center"
            justifyContent="center"
            alignItems="center"
            style={{ minHeight: '100vh', backgroundColor: '#f4f6f8' }}
        >
            <Grid item xs={10} sm={6} md={3}>
                <Box mb={2}>
                    <Typography variant="h5" gutterBottom sx={{ color: '#004F86' }}>
                        <strong>Cambiar Contraseña</strong>
                    </Typography>
                </Box>

                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleChangePassword(newPassword);
                    }}
                >
                    <TextField
                        label="Nueva Contraseña"
                        type="password"
                        fullWidth
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        style={{ marginBottom: '20px' }}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={loading}
                        style={{ marginBottom: '20px' }}
                    >
                        {loading ? 'Cambiando...' : 'Cambiar Contraseña'}
                    </Button>
                </form>

                {error && (
                    <Typography variant="body2" color="error" sx={{ marginBottom: '10px' }}>
                        {error}
                    </Typography>
                )}

                {message && (
                    <Typography variant="body2" color="success" sx={{ marginBottom: '10px' }}>
                        {message}
                    </Typography>
                )}
            </Grid>
        </Grid>
    );
};

export default ChangePasswordPage;
